export default __webpack_public_path__ + "static/media/ls3_g06.20ad146f.png";